// People and organisation (/org: the org tree, collabs, OGSM, insight, My
// tasks) belongs to Convenor for Government. In Convenor for EU projects it
// is hidden unless the organisation has it switched on (Me.org.orgArea; the
// API does the same, apps/api/src/core/org-area.ts): no menu entry, and its
// pages show the normal "Page not found".
import { Outlet } from "react-router";
import type { Me } from "@convenor/shared";
import { NotFoundContent } from "../ui/QueryStates";
import { useCurrentMe } from "./RequireAuth";

/** Whether the active organisation has People and organisation switched on. */
export function hasOrgArea(me: Me | null | undefined): boolean {
  // GET /api/me is the v3 Me; the v1 type does not know the switch.
  return (me?.org as { orgArea?: boolean } | null | undefined)?.orgArea === true;
}

/** The paths of People and organisation: /org and everything under it. */
export const isOrgAreaPath = (path: string): boolean => path === "/org" || path.startsWith("/org/");

/** Route layout around the /org pages: the page when the switch is on, else "Page not found". */
export function OrgAreaGate() {
  const me = useCurrentMe();
  return hasOrgArea(me) ? <Outlet context={me} /> : <NotFoundContent />;
}
